import React, { useEffect, useState } from 'react';
import FilterTags from './FilterTags';
import ReactDOM from "react-dom"
import Collapsible from './Collapsible';
import { translate } from '../Services/translation';
import { getSwatchStyle } from '../Services/FacetedSearch.service';

const FacetedSearchGroup = props => {
    const { group, searchFacetChange } = props
    const [isOpen, setIsOpen] = useState(true)
    const [brandInputValue, setBrandInputValue] = useState("");
    const groupRef = React.createRef();
    const label = <div>{group.label}{group.selectedOptions.length > 0 ? <span>({group.selectedOptions.length})</span> : ""}</div>
    const specialFilterIds = ["FilterColor","Size","Brand","Price"];

    const applyGroupClass = () => {
        if(!groupRef || !groupRef.current) {
            return;
        }
        if(groupRef.current.clientHeight < 280 || (groupRef.current.scrollHeight - groupRef.current.scrollTop - groupRef.current.clientHeight < 1))  {
            groupRef.current.closest(".collapsible__content").classList.add("remove-gradient");
        }
        else {
            groupRef.current.closest(".collapsible__content").classList.remove("remove-gradient"); 
        }
    }

    useEffect(() => {
        applyGroupClass()
    },[groupRef])

    const onGroupScroll = () => {
        applyGroupClass()
    }

    return <Collapsible initiallyOpen={false} label={label} className={"filter-group" + (isOpen ? " filter-group--open" : "")} onStateChange={open => setIsOpen(open)}>
        {!specialFilterIds.includes(group.id) && <ul className="filter-list-wrapper" ref={groupRef} onScroll={onGroupScroll}>
            {group.options && group.options.map((item, idx, array) => (
                <li key={`${item.label}-${item.id}`}>
                    <FacetedFilterCheckbox item={item} group={group} searchFacetChange={searchFacetChange}/>
                </li>
            ))}
        </ul> }
        {group.id == "FilterColor" && 
            <ul className="filter-list-wrapper" ref={groupRef} onScroll={onGroupScroll}>
                {group.options && group.options.map((item, idx, array) => (
                    <li key={`${item.label}-${item.id}`}>
                        <FacetedColorCheckbox textOptionValue={item.textOptionValue} item={item} group={group} searchFacetChange={searchFacetChange}/>
                    </li>
                ))}
            </ul>
        }
        {group.id == "Size" && 
            <ul className="filter-list-wrapper filter-list-wrapper--size" ref={groupRef} onScroll={onGroupScroll}>
                {group.options && group.options.map((item, idx, array) => (
                    <li key={`${item.label}-${item.id}`}>
                        <FacetedSizeCheckbox item={item} group={group} searchFacetChange={searchFacetChange}/>
                    </li>
                ))}
            </ul>
        }
        {group.id == "Price" && 
            <ul className="filter-list-wrapper" ref={groupRef} onScroll={onGroupScroll}>
                {group.options && group.options.map((item, idx, array) => (
                    <li key={`${item.label}-${item.id}`}>
                        <FacetedFilterCheckbox item={item} group={group} searchFacetChange={searchFacetChange}/>
                    </li>
                ))}
            </ul>
        }
        {group.id == "Brand" && <>
            <input placeholder={translate('global.search')} className="brand-search" type="search" onChange={e => setBrandInputValue(e.target.value)}/>
            <ul className="filter-list-wrapper" ref={groupRef} onScroll={onGroupScroll}>
                {group.options && group.options.filter(item => brandInputValue == "" || group.selectedOptions.includes(item.id) || item.label.toLowerCase().includes(brandInputValue.toLowerCase())).sort((a, b) => a.label > b.label ? 1 : -1).map((item, idx, array) => (
                    <li key={`${item.label}-${item.id}`}>
                        <FacetedBrandCheckbox item={item} group={group} searchFacetChange={searchFacetChange}/>
                    </li>
                ))}
            </ul>
        </>
        }
    </Collapsible>
}

const FacetedSearch = ({facetFilters, searchFacetChange, navigationTheme}) => navigationTheme !== 'category' && (
    <>
        {facetFilters && ReactDOM.createPortal(
            <FilterTags searchFacetChange={searchFacetChange} facetFilters={facetFilters} navigationTheme={navigationTheme} />, 
            document.getElementById("filterTags")
        )}
        {facetFilters && facetFilters.map((group, groupIndex, array) => (
            <FacetedSearchGroup key={`${group.label}-${group.id}`} open={true} label={group.label} group={group} searchFacetChange={searchFacetChange}/>
        ))} 
    </>
)
const FacetedFilterCheckbox = ({item, group, searchFacetChange}) => (
    <div className="checkbox-wrapper" >
        <label className="checkbox-wrapper--label">
            <input type="checkbox" className="checkbox-wrapper--input" onChange={event => searchFacetChange(group, item)} checked={group.selectedOptions != null && group.selectedOptions.includes(item.id)} />
            {item.label}
            {!isNaN(item.quantity) && (item.quantity != null) && 
                <span className="checkbox-wrapper--quantity">&nbsp;({item.quantity})</span>
            }
        </label>
    </div>
)
const FacetedSizeCheckbox = ({item, group, searchFacetChange}) => (
    <div className="checkbox-wrapper checkbox-wrapper--size" >
        <label className="checkbox-wrapper--label">
            <input type="checkbox" className="checkbox-wrapper--input" onChange={event => searchFacetChange(group, item)} checked={group.selectedOptions != null && group.selectedOptions.includes(item.id)} />
            {item.label}
            {!isNaN(item.quantity) && (item.quantity != null) && 
                <span className="checkbox-wrapper--quantity">&nbsp;({item.quantity})</span>
            }
        </label>
    </div>
)

const FacetedBrandCheckbox = ({item, group, searchFacetChange}) => (
    <div className="checkbox-wrapper" >
        <label className="checkbox-wrapper--label">
            <input type="checkbox" className="checkbox-wrapper--input" onChange={event => searchFacetChange(group, item)} checked={group.selectedOptions != null && group.selectedOptions.includes(item.id)} />
            {item.label}
            {!isNaN(item.quantity) && (item.quantity != null) && 
                <span className="checkbox-wrapper--quantity">&nbsp;({item.quantity})</span>
            }
        </label>
    </div>
)


const FacetedColorCheckbox = ({item, group, searchFacetChange, textOptionValue}) => {
    const checked = group.selectedOptions && group.selectedOptions.includes(item.id);
    
    return <div className="color-filter" onClick={() => searchFacetChange(group, item)}>
        <div className="color-checkbox-wrapper">
            <input type="checkbox" className="hidden-checkbox" onChange={() => searchFacetChange(group, item)} checked={checked} />
            <label className="color-checkbox-wrapper--label"><div style={getSwatchStyle(textOptionValue, checked)}></div></label>
        </div>
        {item.label}
    </div>
}

export default FacetedSearch;
